var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-shared-animated-icon-arrow",class:{ 'c-shared-animated-icon-arrow--dark': _vm.isDark }},[_c('div',{staticClass:"c-shared-animated-icon-arrow__inner"},[_c('icon',{attrs:{"icon":"arrow-right"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }